<script lang="ts" setup>
import { useI18n } from '#i18n';
import { XLink } from '@clicksign/excalibur';

import { INTERNAL_LINKS } from '~~core';

const { locale } = useI18n();

const termsOfAgreementLink = computed(() => (locale.value === 'es-MX' ? INTERNAL_LINKS['es-MX'].termsOfAgreement : INTERNAL_LINKS.termsOfAgreement));
const privacyPolicyLink = computed(() => (locale.value === 'es-MX' ? INTERNAL_LINKS['es-MX'].privacyPolicy : INTERNAL_LINKS.privacyPolicy));
</script>

<template>
  <footer :class="$style.footer">
    <i18nT
      tag="small"
      keypath="requirement.footer.title"
    >
      <XLink
        :to="termsOfAgreementLink"
        target="_blank"
        no-padding
      >
        {{ $t('requirement.footer.termsOfAgreement') }}
      </XLink>

      <XLink
        :to="privacyPolicyLink"
        target="_blank"
        no-padding
      >
        {{ $t('requirement.footer.privacyPolicy') }}
      </XLink>
    </i18nT>
  </footer>
</template>

<style lang="scss" module>
.footer {
  display: flex;
  flex-direction: column;
  max-width: var(--step-max-width);
  margin: auto;
  margin-bottom: var(--space-medium);
  text-align: center;
  color: var(--color-neutral-700);
}
</style>
